export default __webpack_public_path__ + "static/media/header5.58d3a372.png";